import { Button } from "baseui/button"
import { ParagraphXSmall } from "baseui/typography"
import {  OperatorPanelWrapperFullSize } from "../../components/Layout"
import { ValueDisplayWithLabel } from "../../components/ValueDisplay"
import { TOperationHoursCounter } from "./types"
import TimeAgo from 'react-timeago'
import { useSetObjectValue } from "../../../hooks/useSetObjectValue"
import { FormattedMessage, useIntl } from "react-intl"
import { TimeSeriesBarChart } from "../../../features/Charts/LineCharts/TimeSeriesBarChart"
import { TBarChartItem } from "../../../features/Charts/LineCharts/types"
import { useStyletron } from "baseui"


export const OperatorPanel = (props: TOperationHoursCounter) => {
    const [css,theme] = useStyletron()
    const intl = useIntl();
    const [reset, setReset] = useSetObjectValue(props.id, props.resourceGroupId, "reset", props.reset);
    const lines: TBarChartItem[] = [{
        label: intl.formatMessage({ id: "Devices.OperatingHours"}),
        objectId: props.id,
        propertyName: "valueDelta",
        resourceGroupId: props.resourceGroupId,
        dimension: 'h',
        lineColor: theme.colors.accent
    }]
    return (
        <OperatorPanelWrapperFullSize
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    <ValueDisplayWithLabel label={<FormattedMessage id="Devices.OperatingHours" defaultMessage="Operating Hours" />} dimension={"h"} value={props.value}></ValueDisplayWithLabel>
                    {props.timeOfReset && <ParagraphXSmall><FormattedMessage id="OperationHoursCounter.LastReset" defaultMessage={"Last reset:"}></FormattedMessage> <TimeAgo date={props.timeOfReset} ></TimeAgo> </ParagraphXSmall>}
                </>
            }
            operationModeContent={
                <>
                    <Button kind="secondary" onClick={() => setReset(true)} disabled={props.value === 0 || reset || setReset.isLoading}><FormattedMessage id="OperationHoursCounter.Reset" defaultMessage="Reset" /></Button>
                </>
            }
            additionalContent={
                <TimeSeriesBarChart showAverage showMinValue showMaxValue summarizeBy={'1d'} lines={lines} timespan={60 * 24 * 30}></TimeSeriesBarChart>
            }
        >
        </OperatorPanelWrapperFullSize>
    )

}

